import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import tr from './tr.json';
import en from './en.json';
import { STORAGE_KEYS, storage } from '@/lib/storage';

export const LANGUAGES = ['tr', 'en'] as const;
export type Language = (typeof LANGUAGES)[number];

export function storedLanguage(): Language | null {
  const v = storage.get(STORAGE_KEYS.lang);
  return v === 'tr' || v === 'en' ? v : null;
}

void i18n.use(initReactI18next).init({
  resources: { tr: { translation: tr }, en: { translation: en } },
  lng: storedLanguage() ?? 'tr',
  fallbackLng: 'tr',
  supportedLngs: LANGUAGES,
  interpolation: { escapeValue: false },
  returnNull: false,
});

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});
document.documentElement.lang = i18n.language;

export function setLanguage(lng: Language) {
  storage.set(STORAGE_KEYS.lang, lng);
  void i18n.changeLanguage(lng);
}

export default i18n;
